import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "estate-offer-list",
  class: "estate-offer-list"
}
const _hoisted_2 = {
  key: 0,
  class: "filter-form-wrap"
}
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "form-heading"
}
const _hoisted_5 = {
  key: 1,
  class: "form-field full-width filter-toggle"
}
const _hoisted_6 = { class: "form-field full-width" }
const _hoisted_7 = {
  for: "frm_estateFilter-searchTerm",
  class: "form-label"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "form-field" }
const _hoisted_10 = {
  for: "frm_estateFilter-adtype",
  class: "form-label"
}
const _hoisted_11 = { class: "form-field" }
const _hoisted_12 = {
  for: "frm_estateFilter-estateSubType",
  class: "form-label"
}
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = {
  for: "frm_estateFilter-status",
  class: "form-label"
}
const _hoisted_15 = { class: "selectbox" }
const _hoisted_16 = { value: null }
const _hoisted_17 = { value: "published" }
const _hoisted_18 = { value: "unpublished" }
const _hoisted_19 = { value: "archived" }
const _hoisted_20 = {
  key: 0,
  class: "form-field"
}
const _hoisted_21 = {
  for: "frm_estateFilter-estateAgent",
  class: "form-label"
}
const _hoisted_22 = { class: "selectbox" }
const _hoisted_23 = { value: null }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-field" }
const _hoisted_26 = {
  for: "frm_estateFilter-location",
  class: "form-label"
}
const _hoisted_27 = { class: "form-field" }
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = { class: "multiple-inputs" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "width-wrap" }
const _hoisted_33 = {
  key: 0,
  class: "estate-listing-filter"
}
const _hoisted_34 = { class: "estate-listing-filter__item" }
const _hoisted_35 = { class: "estate-listing-filter__item-label" }
const _hoisted_36 = { class: "estate-listing-filter__item-value" }
const _hoisted_37 = {
  key: 1,
  class: "no-records"
}
const _hoisted_38 = {
  key: 2,
  class: "estate-listing"
}
const _hoisted_39 = {
  key: 0,
  class: "section section--padding-sm pb-0"
}
const _hoisted_40 = { class: "width-wrap" }
const _hoisted_41 = { class: "help-box" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "help-box__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_AdOfferListItem = _resolveComponent("AdOfferListItem")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("form", {
                class: "filter-form",
                onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
                autocomplete: "off"
              }, [
                (_ctx.showFormHeading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('components.AdOfferList.title')) + " " + _toDisplayString(_ctx.pagedList.totalCount), 1))
                  : _createCommentVNode("", true),
                (_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (!_ctx.isFilterExtended)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "button-toggle-show",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterToggle(true)))
                          }, _toDisplayString(_ctx.$t('components.AdOfferList.show-extended-filter')), 1))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "button-toggle-hide",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterToggle(false)))
                          }, _toDisplayString(_ctx.$t('components.AdOfferList.hide-extended-filter')), 1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isFilterExtended)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('components.AdOfferList.searchTerm')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: _ctx.$t('components.AdOfferList.searchTerm-placeholder'),
                          id: "frm_estateFilter-searchTerm",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.queryParams.searchTerm) = $event))
                        }, null, 8, _hoisted_8), [
                          [
                            _vModelText,
                            _ctx.queryParams.searchTerm,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('components.AdOfferList.adtype')) + ":", 1),
                        _createVNode(_component_multiselect, {
                          id: "frm_estateFilter-adtype",
                          modelValue: _ctx.queryParams.type,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.queryParams.type) = $event)),
                          "track-by": "key",
                          label: "value",
                          "show-labels": false,
                          options: _ctx.adTypes,
                          searchable: false,
                          "close-on-select": true,
                          placeholder: _ctx.$t('components.AdOfferList.adtype-placeholder'),
                          multiple: false,
                          "allow-empty": true
                        }, null, 8, ["modelValue", "options", "placeholder"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('components.AdOfferList.estateSubType')) + ":", 1),
                        _createVNode(_component_multiselect, {
                          id: "frm_estateFilter-estateSubType",
                          modelValue: _ctx.queryParams.estateFrontSubTypes,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.queryParams.estateFrontSubTypes) = $event)),
                          "track-by": "key",
                          label: "value",
                          "show-labels": false,
                          options: _ctx.estateTypes,
                          "group-values": "estateSubTypes",
                          "group-label": "value",
                          placeholder: _ctx.$t('components.AdOfferList.estateSubType-placeholder'),
                          "group-select": true,
                          searchable: true,
                          "close-on-select": false,
                          multiple: true,
                          "allow-empty": true
                        }, {
                          noResult: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "placeholder"])
                      ]),
                      (!_ctx.isPublic)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('components.AdOfferList.status')) + ":", 1),
                              _createElementVNode("div", _hoisted_15, [
                                _withDirectives(_createElementVNode("select", {
                                  id: "frm_estateFilter-status",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status) = $event))
                                }, [
                                  _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('components.AdOfferList.all-status')), 1),
                                  _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('components.AdOfferList.published')), 1),
                                  _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('components.AdOfferList.unpublished')), 1),
                                  _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('components.AdOfferList.archive')), 1)
                                ], 512), [
                                  [_vModelSelect, _ctx.status]
                                ])
                              ])
                            ]),
                            (!_ctx.isUserList)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('components.AdOfferList.agent')) + ":", 1),
                                  _createElementVNode("div", _hoisted_22, [
                                    _withDirectives(_createElementVNode("select", {
                                      id: "frm_estateFilter-estateAgent",
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.queryParams.frontUserId) = $event))
                                    }, [
                                      _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t('components.AdOfferList.all')), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateAgents, (item) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          value: item.frontUserId,
                                          key: item.frontUserId
                                        }, _toDisplayString(item.fullName), 9, _hoisted_24))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.queryParams.frontUserId]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('components.AdOfferList.location')) + ":", 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "frm_estateFilter-location",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.queryParams.location) = $event))
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.queryParams.location,
                                  void 0,
                                  { lazy: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('components.AdOfferList.price')) + ":", 1),
                              _createElementVNode("div", _hoisted_29, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.queryParams.priceFrom) = $event)),
                                  placeholder: _ctx.$t('components.AdOfferList.price-from')
                                }, null, 8, _hoisted_30), [
                                  [
                                    _vModelText,
                                    _ctx.queryParams.priceFrom,
                                    void 0,
                                    {
                                      number: true,
                                      lazy: true
                                    }
                                  ]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.queryParams.priceTo) = $event)),
                                  placeholder: _ctx.$t('components.AdOfferList.price-to')
                                }, null, 8, _hoisted_31), [
                                  [
                                    _vModelText,
                                    _ctx.queryParams.priceTo,
                                    void 0,
                                    {
                                      number: true,
                                      lazy: true
                                    }
                                  ]
                                ])
                              ])
                            ])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_32, [
        (_ctx.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('components.AdOfferList.sort')) + ":", 1),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_multiselect, {
                    class: "multiselect-simple",
                    modelValue: _ctx.sortBy,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sortBy) = $event)),
                    preselectFirst: true,
                    options: _ctx.sortByTypes,
                    "show-labels": false,
                    searchable: false,
                    "allow-empty": false,
                    "track-by": "value",
                    label: "title"
                  }, {
                    singleLabel: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(option.title), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(option.icon)
                      }, null, 2)
                    ]),
                    option: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(option.title), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(option.icon)
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading && _ctx.pagedList.data.length === 0 && !_ctx.isDeveloperProjectList)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.$t('components.AdOfferList.no-records')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList.data, (item, index) => {
                return (_openBlock(), _createBlock(_component_AdOfferListItem, {
                  key: item.adId,
                  ad: item,
                  isEmailConfirmed: _ctx.isEmailConfirmed,
                  isPublic: _ctx.isPublic,
                  isDeveloperProject: _ctx.isDeveloperProjectList,
                  isBannerVisible: index === 2,
                  showAgent: !_ctx.isEstateAgentList,
                  onPublishChange: _ctx.onPublishChange,
                  onReservedChange: _ctx.onReservedChanged,
                  onArchivedChange: _ctx.onArchivedChanged
                }, null, 8, ["ad", "isEmailConfirmed", "isPublic", "isDeveloperProject", "isBannerVisible", "showAgent", "onPublishChange", "onReservedChange", "onArchivedChange"]))
              }), 128))
            ])),
        _createVNode(_component_Pagination, {
          currentPage: _ctx.pagedList.page,
          pageSize: _ctx.pagedList.pageSize,
          currentCount: _ctx.pagedList.currentCount,
          totalCount: _ctx.pagedList.totalCount,
          onLoadPage: _ctx.pageChangeHandle
        }, null, 8, ["currentPage", "pageSize", "currentCount", "totalCount", "onLoadPage"])
      ])
    ]),
    (!_ctx.isLoading && _ctx.isDeveloperProjectList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", {
                class: "help-box__content",
                innerHTML: _ctx.$t('components.AdOfferList.developer-project.content')
              }, null, 8, _hoisted_42),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_router_link, {
                  to: { name: 'AdDeveloperProjectFormCreate' },
                  tag: "a",
                  class: "button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('components.AdOfferList.developer-project.button')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}